'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('./style');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    width: {
      type: [Number, String],
      default: 100
    },
    height: {
      type: [Number, String],
      default: 600
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    activeFontSize: {
      type: Number,
      default: 28
    },
    activeTextColor: {
      type: String,
      default: ''
    },
    activeBlockColor: {
      type: String,
      default: ''
    },
    defaultStyle: {
      type: Object,
      default: function _default() {
        return {
          width: 200,
          height: 96,
          fontSize: 28
        };
      }
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    backgroundColor: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {};
  },

  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || (this._isDiablo ? 'diablo' : 'default');
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    defaultItemStyle: function defaultItemStyle() {
      var _defaultStyle = this.defaultStyle,
          width = _defaultStyle.width,
          height = _defaultStyle.height;

      var eleSty = {
        width: width + 'px',
        height: height + 'px'
      };
      return eleSty;
    },
    defaultTextStyle: function defaultTextStyle() {
      var _defaultStyle2 = this.defaultStyle,
          height = _defaultStyle2.height,
          fontSize = _defaultStyle2.fontSize,
          color = _defaultStyle2.color;

      if (!color) color = this.themeStyle.textColor;
      var eleSty = {
        fontSize: fontSize + 'px',
        color: color,
        lineHeight: height + 'px'
      };
      return eleSty;
    },
    activeTextStyle: function activeTextStyle() {
      var height = this.defaultStyle.height;

      var fontSize = this.activeFontSize;
      var color = this.activeTextColor ? this.activeTextColor : this.themeStyle.activeTextColor;
      var eleSty = {
        fontSize: fontSize + 'px',
        color: color,
        lineHeight: height + 'px',
        fontWeight: 'bold',
        backgroundColor: this.themeStyle.activeBackgroundColor
      };
      if (this._isColmo) eleSty.fontWeight = 'normal';
      return eleSty;
    },
    sideNavStyle: function sideNavStyle() {
      var width = this.defaultStyle.width;
      var height = this.height,
          backgroundColor = this.backgroundColor;

      if (!backgroundColor) backgroundColor = this.themeStyle.backgroundColor;
      var eleSty = {
        width: width + 'px',
        height: height + 'px',
        backgroundColor: backgroundColor
      };
      return eleSty;
    },
    activeBoxStyle: function activeBoxStyle() {
      var height = this.defaultStyle.height;

      var eleSty = {
        height: height + 'px'
      };
      return eleSty;
    },
    activeLineStyle: function activeLineStyle() {
      var height = this.defaultStyle.height;
      var activeBlockColor = this.activeBlockColor;

      if (!activeBlockColor) activeBlockColor = this.themeStyle.activeBlockColor;
      var eleSty = {
        backgroundColor: activeBlockColor,
        height: '24px'
      };
      if (this._isColmo) eleSty.height = height + 'px';
      return eleSty;
    }
  },
  methods: {
    dofItemClick: function dofItemClick(item, index) {
      this.activeIndex = index;
      this.$emit('dofItemClick', { item: item, index: index });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-side-nav/index.vue
// module id = 384
// module chunks = 0 1